import { BottomModal } from "components/common/BottomModal/BottomModal";
import { Translate } from "components/common/Translate/Translate";
import { Color } from "./Color/Color";
import { Source } from "./Source/Source";
import { UploadImage } from "./UploadImage/UploadImage";
import { useColorPickerSettings } from "./useColorPickerSettings";
import { ColorHarmonies } from "./ColorHarmonies/ColorHarmonies";
import { ColorVariants } from "./ColorVariants/ColorVariants";
import { ContrastChecker } from "./ContrastChecker/ContrastChecker";

export const ColorPickerSettings = () => {
    const { source, selectedColor } = useColorPickerSettings();

    return (
        <div className="flex flex-col gap-8 pb-8 pt-4">
            <Source />
            {source === "image" && <UploadImage />}
            <Color />

            <BottomModal
                isOpen={true}
                initialHeight="30vh"
                minimumHeight={10}
                parentClassNames={`lg:hidden ${!selectedColor && `hidden`}`}
                interactiveBackground={true}
                lockBackground={false}
                titleBar={
                    <div className="pt-4 capitalize text-xl w-full text-center font-semibold text-black dark:text-white">
                        <Translate keyName="color-codes" />
                    </div>
                }
            >
                <div className="flex flex-col gap-8 text-black dark:text-white py-4">
                    <Color />
                    <ColorVariants useHeadingTag={false}/>
                    <ColorHarmonies useHeadingTag={false}/>
                    <ContrastChecker/>
                </div>
            </BottomModal>
        </div>
    );
};
